<template>
    <v-dialog value="true" width="500" elevation="8" fade>
        <v-card>
            <v-card-title
                class="headline grey lighten-2"
                primary-title
            >
                <span v-if="moduleKey!='buyer'">Confirm: Submit for Review</span>
                <span v-else>Confirm: Completed Buyer Profile</span>
            </v-card-title>

            <v-card-text class="mt-3">

                <template v-if="hasUnanswered">
                    <div class="mb-3">
                        <p>You have unanswered questions in the following sections.  Please review any unanswered questions before submitting for review.</p>

                        <template
                            v-for="section in value"
                        >
                            <div
                                v-if="section.unfinished.length && section.visible"
                                :key="section.value"
                                class="unanswered-section-wrapper"
                            >
                                <a
                                    @click="navigateToSection(section.value)"
                                >
                                    <h3>{{section.title}}</h3>
                                </a>
                                <div>Unanswered Questions: {{section.unfinished.length}}</div>
                                <div
                                    v-if="requiredCountBySection(section.value)"
                                    class="error--text"
                                >
                                    Required Questions: {{requiredCountBySection(section.value)}}
                                </div>
                            </div>
                        </template>
                    </div>
                </template>

                <v-checkbox
                    v-if="!hasRequiredUnanswered && hasUnanswered && moduleKey!=='buyer' && !moduleKey.includes('-starter')"
                    v-model="acknowledgeIncomplete"
                    class="confirm_check mt-n12"
                    label="I understand that I have not completed all suggested questions.  I would like to submit this form in an incomplete state with the intention of completing this form while working with an SRG associate."
                />
                
                <v-divider v-if="!hasRequiredUnanswered && hasUnanswered && !moduleKey.includes('-starter')" class="mt-2 mb-4"></v-divider>

                <template
                    v-if="canSubmit"
                >
                    <div v-if="moduleKey==='buyer'">
                        <p>By clicking the confirm button below you are affirming that the information provided in your buyer profile is accurate and up-to-date.</p>
                        <p>After confirming, you will be able to express interest on any available listing in the "Listings" area. Feel free to make changes to your profile, but you will not be able to express interest until your profile is 100% complete.</p>
                        <p>We will contact you with any questions we have concerning the information in your buyer profile.</p>
                    </div>
                    <div v-else>
                        <div>
                            <p>By clicking the confirm button below you are affirming that the information provided in this questionnaire is accurate and up-to-date.</p>
                            <p>While your submitted questionnaire is under review, you will be able to see the answers you've entered, but will not be able to change or alter anything during this time.</p>
                            <p>We will contact you with any questions we have concerning this information and will be in touch with you with next steps shortly.</p>
                        </div>
                    </div>
                    
                </template> 
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="warning"
                    text
                    @click="onCancel"
                    >
                    Cancel
                </v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="onConfirm"
                    :disabled="!canSubmit || (!hasRequiredUnanswered && hasUnanswered && !acknowledgeIncomplete && moduleKey!=='buyer' && !moduleKey.includes('-starter'))"
                    >
                    Confirm
                    
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ConfirmDialog',
        props: [
            'moduleKey',
            'value',
        ],
        data: function () {
            return {
                acknowledgeIncomplete: false,
                hasRequiredUnanswered: false
            };
        },
        methods: {
            onCancel: function () {
                this.$emit('cancel');
            },
            onConfirm: function () {
                this.$emit('confirm');
            },
            requiredCountBySection: function (section) {
                const thisSection = this.value[section];
                let count = 0;

                if (thisSection.unfinished && thisSection.unfinished.length && thisSection.visible) {
                    thisSection.unfinished.forEach((thisUnfinished) => {
                        if (thisSection.required.indexOf(thisUnfinished.name) >= 0) {
                            count++;
                            this.hasRequiredUnanswered = true
                        }
                    });
                }

                return count;
            },
            navigateToSection: function (section) {
                this.$emit('navigate', section);
            }
        },
        computed: {
            canSubmit: function () {
                const self = this;

                return Object.keys(this.value).every((thisSectionKey) => self.requiredCountBySection(thisSectionKey) === 0);
            },
            hasUnanswered: function () {
                const self = this;

                return Object.keys(this.value).some((thisSectionKey) => {
                    const thisSection = self.value[thisSectionKey];

                    return thisSection.unfinished && thisSection.unfinished.length && thisSection.visible;
                });
            }
        }
    };
</script>

<style scoped>
    .unanswered-section-wrapper {
        margin-top: 0.5em;
        margin-bottom: 0.5em;
    }
    .confirm_check >>> label {
        font-size: .9em;
        margin-top: 4em;
    }
</style>



// WEBPACK FOOTER //
// src/components/questionnaire_template/confirm-dialog.vue